<template>
  <div class="menu-wrapper">
    <template>
      <router-link :to="resolvePath(onlyOneChild.path)" v-if="!item.hidden && hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">
          <i class="iconfont" :class="onlyOneChild.meta && onlyOneChild.meta.icon"></i> {{ onlyOneChild.meta && onlyOneChild.meta.title }}
        </el-menu-item>
      </router-link>
    </template>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>

<style lang="less" scoped>
.menu-wrapper {
  width: 100%;
}
</style>
<style lang="less">
.menu-wrapper {
  .el-menu-item {
    font-size: 14px;
    line-height: 56px;
    height: 56px;
    padding: 0;
    width: 100%;
    color: #fff !important;
    text-shadow: 0 1px 6px #999;
    padding: 0 15px;
    cursor: pointer;
    &:focus, &:hover {
      background-color: transparent;
    }
    &.is-active {
      color: #fff !important;
      background-color: #42a3df;
    }
    .iconfont {
      font-size: 20px;
      margin-right: 10px;
    }
  }
}
</style>